module.exports = __webpack_public_path__ + "img/metamask.0302f731.png";